import { MerchandiseShippingOrderCreationItem } from 'api/order'
import getMerchandiseShippingItemViews from 'checkout/selectors/view/itemViews/getMerchandiseShippingItemViews'
import { nonNullable } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import { getAllPromoCodeItemDiscounts } from '../checkout'
import { filterItemDiscounts, PromoItemDiscountsWithStatus } from 'lib/promo/promoMappers'
import formatItemDiscount from 'lib/payment/formatDiscountItem'

const getFormattedMerchandiseShippingItems = createSelector(
  (state: App.State) => getMerchandiseShippingItemViews(state),
  (state: App.State) => state.checkout.form.deliveryForm,
  (state: App.State) => getAllPromoCodeItemDiscounts(state),
  (views, form, itemDiscounts: PromoItemDiscountsWithStatus): Array<MerchandiseShippingOrderCreationItem> => {
    const items = views.data.map((view): MerchandiseShippingOrderCreationItem | undefined => {
      // Validate required fields
      if (!form.phoneNumber ||
        !form.firstName ||
        !form.lastName ||
        !form.address ||
        !form.city ||
        !form.state ||
        !form.postcode
      ) {
        return undefined
      }

      const thisItemDiscounts = filterItemDiscounts({
        itemDiscounts: itemDiscounts.itemDiscounts,
        lookup: {
          specificType: 'cart-id-based',
          cartItemIds: [view.item.itemId ?? ''],
        },
      })

      return {
        type: 'merchandise_shipping',
        transaction_key: view.item.transactionKey,
        total: view.totals.otherFees?.deliveryFee ?? 0,
        shippingGst: view.totals.otherFees?.deliveryGst,
        shippingGroup: view.item.itemId,
        itemDiscounts: thisItemDiscounts.map(formatItemDiscount),
        address: {
          firstName: form.firstName,
          lastName: form.lastName,
          company: form.company,
          country: form.country ?? 'Australia',
          phone: `+${form.phoneNumber.prefix}${form.phoneNumber.phone}`,
          address: form.address,
          address2: form.unitNumber ?? undefined,
          city: form.city,
          state: form.state,
          postcode: form.postcode,
        },
      }
    })

    return nonNullable(items)
  }
)

export default getFormattedMerchandiseShippingItems
